import React from 'react';
import { observer } from 'mobx-react';
import USWDS from 'uswds/src/js/components';
import { mdiCheckCircle, mdiAlphaXCircle, mdiInformationOutline, mdiHelpCircleOutline } from '@mdi/js';
import Icon from '@mdi/react';
import './accordion.scss';

const { accordion } = USWDS;

interface IAccordionProps {
  className?: string;
  children: any;
  waterwayWizardStatus?: number;
  onClickInformationToggle?: any;
  directInformationPath?: string;
  headers: string[];
  expanded?: boolean;
  iconPathQ?: boolean;
  onToggle?: () => void;
  actionButton?: any;
  light?: boolean;
  disabled?: boolean;
}

const AccordionComponent = (props: IAccordionProps) => {
  React.useEffect(() => {
    accordion.on();
  }, []);

  const icon =
    props.waterwayWizardStatus === 3
      ? mdiAlphaXCircle
      : props.waterwayWizardStatus === 2
      ? mdiCheckCircle
      : props.iconPathQ
      ? mdiHelpCircleOutline
      : mdiInformationOutline;

  return (
    <div className={props.className ? props.className : 'padding-3'}>
      <div className="usa-accordion usa-accordion--multiselectable" data-allow-multiple>
        {React.Children.map(props.children, (child, index) => {
          // to get ID as first-word-button-id rather than first word button-id.
          const id = props.headers[index] ? props.headers[index].trim().replace(/ /g, '-') : '';
          return (
            <>
              <div className={`usa-accordion__heading ${props.disabled ? 'accordion-disabled ' : ''}${props.light ? 'usa-accordion__light-heading' : ''}`}>
                <div
                  role="button"
                  tabIndex={0}
                  className="usa-accordion__button"
                  id={id + '-button-id'}
                  aria-expanded={props.expanded !== undefined ? props.expanded : true}
                  aria-controls={id + '-control'}
                  onClick={props.onToggle}
                >
                  <h2>{props.headers[index]}</h2>
                </div>

                {props.waterwayWizardStatus || props.actionButton ? (
                  <div className={`control-buttons`}>
                    {props.actionButton ? props.actionButton : null}

                    {props.onClickInformationToggle ? (
                      <button
                        className="extra-button usa-button usa-button--unstyled"
                        onClick={() => props.onClickInformationToggle(props.headers[0])}
                        aria-label={id + '-button-id-information'}
                        text-alternative="information"
                      >
                        <Icon path={icon} size={1} title={props.headers[index] + ' information'} />
                      </button>
                    ) : null}

                    {props.directInformationPath ? (
                      <a className="extra-button" href={props.directInformationPath} target="_blank" rel="noreferrer">
                        <Icon path={icon} size={1} title={props.headers[index] + ' information'} />
                      </a>
                    ) : null}
                  </div>
                ) : null}
              </div>
              <div
                id={id + '-control'}
                className="usa-accordion__content usa-prose"
                hidden={props.expanded !== undefined && props.expanded ? false : true}
              >
                {child}
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export const Accordion = observer(AccordionComponent);
